import script from "./QueryTouristRoutesView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryTouristRoutesView.vue?vue&type=script&setup=true&lang=js"

import "./QueryTouristRoutesView.vue?vue&type=style&index=0&id=70a223be&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a223be"]])

export default __exports__